import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import Box from "../../Styled/Box";
import { RawButton } from "../../Styled/Button";
import Icon from "../../Styled/Icon";
import Text from "../../Styled/Text";
import PrivateIndicator from "../PrivateIndicator/PrivateIndicator";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export let ButtonState = /*#__PURE__*/function (ButtonState) {
  ButtonState[ButtonState["Loading"] = 0] = "Loading";
  ButtonState[ButtonState["Remove"] = 1] = "Remove";
  ButtonState[ButtonState["Add"] = 2] = "Add";
  ButtonState[ButtonState["Trash"] = 3] = "Trash";
  ButtonState[ButtonState["Stats"] = 4] = "Stats";
  ButtonState[ButtonState["Preview"] = 5] = "Preview";
  return ButtonState;
}({});
const STATE_TO_ICONS = {
  [ButtonState.Loading]: /*#__PURE__*/_jsx(Icon, {
    glyph: Icon.GLYPHS.loader
  }),
  [ButtonState.Remove]: /*#__PURE__*/_jsx(Icon, {
    glyph: Icon.GLYPHS.minus
  }),
  [ButtonState.Add]: /*#__PURE__*/_jsx(Icon, {
    glyph: Icon.GLYPHS.plus
  }),
  [ButtonState.Trash]: /*#__PURE__*/_jsx(Icon, {
    glyph: Icon.GLYPHS.trashcan
  }),
  [ButtonState.Stats]: /*#__PURE__*/_jsx(Icon, {
    glyph: Icon.GLYPHS.barChart
  }),
  [ButtonState.Preview]: /*#__PURE__*/_jsx(Icon, {
    glyph: Icon.GLYPHS.right
  })
};
/** Dumb catalog item */
function CatalogItem(props) {
  var _props$titleOverrides;
  const {
    t
  } = useTranslation();
  const STATE_TO_TITLE = {
    [ButtonState.Loading]: t("catalogItem.loading"),
    [ButtonState.Remove]: t("catalogItem.remove"),
    [ButtonState.Add]: t("catalogItem.add"),
    [ButtonState.Trash]: t("catalogItem.trash"),
    [ButtonState.Preview]: t("catalogItem.preview")
  };
  const stateToTitle = (_props$titleOverrides = props.titleOverrides) !== null && _props$titleOverrides !== void 0 ? _props$titleOverrides : STATE_TO_TITLE;
  return /*#__PURE__*/_jsxs(Root, {
    children: [/*#__PURE__*/_jsx(Text, {
      fullWidth: true,
      primary: props.isPrivate,
      bold: props.selected,
      breakWord: true,
      children: /*#__PURE__*/_jsx(ItemTitleButton, {
        selected: props.selected,
        trashable: props.trashable,
        type: "button",
        onClick: props.onTextClick,
        title: props.title,
        children: props.text
      })
    }), /*#__PURE__*/_jsxs(Box, {
      children: [props.isPrivate && /*#__PURE__*/_jsx(PrivateIndicator, {}), /*#__PURE__*/_jsx(ActionButton, {
        type: "button",
        onClick: props.onBtnClick,
        title: stateToTitle[props.btnState] || "",
        children: STATE_TO_ICONS[props.btnState]
      }), props.trashable && /*#__PURE__*/_jsx(ActionButton, {
        type: "button",
        onClick: props.onTrashClick,
        title: stateToTitle[ButtonState.Trash],
        children: STATE_TO_ICONS[ButtonState.Trash]
      })]
    })]
  });
}
const Root = styled.li.withConfig({
  displayName: "CatalogItem__Root",
  componentId: "sc-7i65e4-0"
})(["display:flex;width:100%;"]);
const ItemTitleButton = styled(RawButton).withConfig({
  displayName: "CatalogItem__ItemTitleButton",
  componentId: "sc-7i65e4-1"
})(["text-align:left;word-break:normal;overflow-wrap:anywhere;padding:10px;width:100%;font-size:0.8125rem;&:focus,&:hover{color:", ";}", " @media (max-width:", "px){font-size:0.9rem;padding-top:10px;padding-bottom:10px;border-bottom:1px solid ", ";}"], p => p.theme.modalHighlight, p => p.selected && "color: ".concat(p.theme.modalHighlight, ";"), p => p.theme.sm, p => p.theme.greyLighter);
const ActionButton = styled(RawButton).withConfig({
  displayName: "CatalogItem__ActionButton",
  componentId: "sc-7i65e4-2"
})(["svg{height:12px;width:12px;margin:5px;fill:", ";}&:hover,&:focus{svg{fill:", ";}}"], p => p.theme.grey, p => p.theme.modalHighlight);
CatalogItem.propTypes = {
  onTextClick: PropTypes.func,
  isPrivate: PropTypes.bool,
  selected: PropTypes.bool,
  text: PropTypes.string,
  title: PropTypes.string,
  trashable: PropTypes.bool,
  onTrashClick: PropTypes.func,
  onBtnClick: PropTypes.func,
  btnState: PropTypes.oneOf([ButtonState.Add, ButtonState.Loading, ButtonState.Preview, ButtonState.Remove, ButtonState.Stats, ButtonState.Trash]),
  titleOverrides: PropTypes.object
};
export default CatalogItem;